export const SHIFT_ANNOUNCE_FORM = 'shiftAnnounceForm'
export const SHIFT_CHECKBOXES = 'shiftCheckboxes'
export const SHIFT_ASSIGN = 'shiftAssign'

export const INITIAL_FORM_VALUES = {
  [SHIFT_CHECKBOXES]: [],
  [SHIFT_ASSIGN]: '',
  [SHIFT_ANNOUNCE_FORM]: ''
}
